import { render, staticRenderFns } from "./PeerReport.vue?vue&type=template&id=551da1c0&"
import script from "./PeerReport.vue?vue&type=script&lang=js&"
export * from "./PeerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports